import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BrandLogo from "../components/BrandLogo";

const TESTIMONIALS = [
  { name: "Sarah M.", state: "Texas",      amount: "$5,000", time: "2 days ago",  avatar: "👩🏻" },
  { name: "James R.", state: "Florida",    amount: "$5,000", time: "5 days ago",  avatar: "👨🏾" },
  { name: "Linda K.", state: "California", amount: "$5,000", time: "1 week ago",  avatar: "👩🏽" },
  { name: "Derek W.", state: "New York",   amount: "$5,000", time: "2 weeks ago", avatar: "👨🏻" },
];

// Fake but convincing deadline 3 days from now
const DEADLINE = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);

const pad = (n) => String(n).padStart(2, "0");

const LandingPage = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState({ h: 0, m: 0, s: 0 });
  const [winners,  setWinners]  = useState(4817);

  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, DEADLINE - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft({ h, m, s });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  // Slowly tick winners up for social proof
  useEffect(() => {
    const id = setInterval(() => {
      setWinners((w) => w + Math.floor(Math.random() * 3));
    }, 8000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="landing-page">

      {/* ── Top bar ── */}
      <div className="landing-topbar">
        <BrandLogo size={80} />
        <div className="topbar-badge">🔒 Secure &amp; Verified</div>
      </div>

      {/* ── Hero ── */}
      <div className="landing-hero">
        <div className="hero-tag">🎉 OFFICIAL CASH GIVEAWAY 2026</div>

        <div className="hero-prize">
          <span className="prize-dollar">$</span>
          <span className="prize-amount">5,000</span>
        </div>
        <div className="hero-subtitle">Cash Prize — Sent Directly to Your Venmo</div>

        {/* Countdown */}
        <div className="countdown-box">
          <div className="countdown-label">⏰ Offer Expires In</div>
          <div className="countdown-timer">
            <div className="countdown-unit">
              <span className="countdown-num">{pad(timeLeft.h)}</span>
              <span className="countdown-unit-label">HRS</span>
            </div>
            <span className="countdown-colon">:</span>
            <div className="countdown-unit">
              <span className="countdown-num">{pad(timeLeft.m)}</span>
              <span className="countdown-unit-label">MIN</span>
            </div>
            <span className="countdown-colon">:</span>
            <div className="countdown-unit">
              <span className="countdown-num">{pad(timeLeft.s)}</span>
              <span className="countdown-unit-label">SEC</span>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="stats-row">
          <div className="stat-item">
            <span className="stat-num">{winners.toLocaleString()}</span>
            <span className="stat-label">Entries So Far</span>
          </div>
          <div className="stat-divider"/>
          <div className="stat-item">
            <span className="stat-num">100</span>
            <span className="stat-label">Winners Selected</span>
          </div>
          <div className="stat-divider"/>
          <div className="stat-item">
            <span className="stat-num">2 min</span>
            <span className="stat-label">To Qualify</span>
          </div>
        </div>

        <button className="cta-btn" onClick={() => navigate("/quiz")}>
          🎁 &nbsp;CHECK IF YOU QUALIFY
        </button>

        <p className="cta-hint">No purchase necessary. Open to US residents 18+.</p>
      </div>

      {/* ── How It Works ── */}
      <div className="section-card">
        <h2 className="section-title">How It Works</h2>
        <div className="steps-row">
          <div className="how-step">
            <div className="how-icon">📝</div>
            <div className="how-title">Answer Questions</div>
            <div className="how-desc">Complete a quick eligibility quiz — takes under 2 minutes</div>
          </div>
          <div className="how-arrow">→</div>
          <div className="how-step">
            <div className="how-icon">💳</div>
            <div className="how-title">Connect Venmo</div>
            <div className="how-desc">Link your Venmo account to receive your cash prize instantly</div>
          </div>
          <div className="how-arrow">→</div>
          <div className="how-step">
            <div className="how-icon">💵</div>
            <div className="how-title">Get Paid</div>
            <div className="how-desc">$5,000 deposited to your Venmo within 24 hours</div>
          </div>
        </div>
      </div>

      {/* ── Recent Winners ── */}
      <div className="section-card">
        <h2 className="section-title">🏆 Recent Winners</h2>
        <div className="testimonials">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="testimonial-avatar">{t.avatar}</div>
              <div className="testimonial-info">
                <div className="testimonial-name">{t.name} — {t.state}</div>
                <div className="testimonial-detail">Won {t.amount} &nbsp;·&nbsp; {t.time}</div>
              </div>
              <div className="testimonial-badge">✓ Verified</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Trust badges ── */}
      <div className="trust-row">
        <div className="trust-item">🔒<br/>256-bit SSL</div>
        <div className="trust-item">✅<br/>FTC Compliant</div>
        <div className="trust-item">🇺🇸<br/>US Only</div>
        <div className="trust-item">⚡<br/>Instant Payout</div>
      </div>

      <button className="cta-btn cta-btn-bottom" onClick={() => navigate("/quiz")}>
        🎁 &nbsp;CLAIM YOUR $5,000 NOW
      </button>

      <footer className="page-footer">
        © 2026 WinBig LLC. All rights reserved. &nbsp;|&nbsp; No purchase necessary.
        Void where prohibited. See official rules for details.
      </footer>
    </div>
  );
};

export default LandingPage;
